module.exports = __webpack_public_path__ + "img/banjo-and-kazooie-min.3f48aa7d.png";